import React from 'react';
import { Search, Plus, Image as ImageIcon, Video, Layers, Smartphone } from 'lucide-react';

export const GoogleMediaSection: React.FC = () => {
  return (
    <div className="w-full bg-white text-slate-900 py-20 px-6 md:px-12 font-sans border-t border-slate-100">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12 items-start text-left">
         
         {/* ITEM 1: SEJA A 1ª NAS BUSCAS DO GOOGLE */}
         <div className="space-y-6">
            <h3 className="text-3xl font-heading font-black text-slate-900 leading-tight">
               Seja a 1ª nas <br /> buscas do google
            </h3>
            {/* SERP Mobile Mockup */}
            <div className="w-full max-w-[280px] bg-slate-50 border border-slate-200 rounded-3xl p-3 space-y-3">
               <div className="bg-white border border-slate-200 rounded-full px-3 py-2 flex items-center gap-2">
                  <span className="text-blue-500 font-bold text-xs">G</span>
                  <span className="text-[11px] text-slate-700 font-medium truncate">seu negócio em 1º lugar</span>
                  <Search className="w-3.5 h-3.5 text-slate-400 ml-auto" />
               </div>
               {/* Organic/Ad Result */}
               <div className="bg-white border border-slate-200 rounded-xl p-3 space-y-1">
                  <span className="text-[9px] font-bold uppercase text-blue-600 block">Patrocinado</span>
                  <h4 className="text-xs font-bold text-blue-900 hover:underline cursor-pointer">Sua Empresa - Referência #1 na Cidade</h4>
                  <p className="text-[10px] text-slate-500 leading-relaxed">
                     Atendimento rápido, produtos com garantia e orçamento sem compromisso. Clique para conferir!
                  </p>
               </div>
            </div>
         </div>

         {/* ITEM 2: DESIGN E EDIÇÃO DE VÍDEOS */}
         <div className="space-y-6">
            <h3 className="text-3xl font-heading font-black text-slate-900 leading-tight">
               Design e Edição <br /> de Vídeos
            </h3>
            {/* Editor Canvas Mockup */}
            <div className="w-full max-w-[300px] bg-slate-50 border border-slate-200 rounded-2xl p-3 relative space-y-2">
               <div className="h-44 bg-slate-900 rounded-xl overflow-hidden relative">
                  <img src="https://images.unsplash.com/photo-1527631746610-bca00a040d60?q=80&w=400&auto=format&fit=crop" className="w-full h-full object-cover" alt="Editor Preview" />
                  {/* Timeline overlay */}
                  <div className="absolute bottom-2 left-2 right-2 bg-slate-900/90 backdrop-blur-sm p-1.5 rounded flex items-center justify-between text-[9px] text-white">
                     <span>00:15 / 00:30</span>
                     <div className="flex gap-1">
                        <div className="w-2 h-2 bg-blue-500 rounded-full" />
                        <div className="w-2 h-2 bg-slate-500 rounded-full" />
                     </div>
                  </div>
               </div>
               <div className="flex items-center justify-between bg-white p-2 rounded-lg border border-slate-200">
                  <span className="text-[10px] font-bold text-slate-700">Trilha de Edição Pro</span>
                  <div className="w-7 h-7 bg-slate-900 text-white rounded-full flex items-center justify-center">
                     <Plus className="w-4 h-4" />
                  </div>
               </div>
            </div>
         </div>

         {/* ITEM 3: COMUNICAÇÃO PROFISSIONAL EM TODAS AS REDES SOCIAIS */}
         <div className="space-y-6">
            <h3 className="text-3xl font-heading font-black text-slate-900 leading-tight">
               Comunicação profissional <br /> em todas as redes
            </h3>
            {/* Instagram Mobile Fan Layout Mockup */}
            <div className="relative w-full max-w-[280px] h-[260px]">
               <div className="absolute inset-0 bg-white border border-slate-200 rounded-3xl p-3 text-left overflow-hidden">
                  <div className="flex items-center gap-2 border-b border-slate-100 pb-2 mb-2">
                     <div className="w-6 h-6 rounded-full bg-slate-200 overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=100&auto=format&fit=crop" className="w-full h-full object-cover" alt="Perfil" />
                     </div>
                     <span className="text-[10px] font-bold text-slate-900">@suaempresa</span>
                  </div>
                  <div className="grid grid-cols-2 gap-1.5">
                     <div className="h-20 bg-slate-100 rounded overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?q=80&w=200&auto=format&fit=crop" className="w-full h-full object-cover" alt="Post 1" />
                     </div>
                     <div className="h-20 bg-slate-100 rounded overflow-hidden">
                        <img src="https://images.unsplash.com/photo-1555396273-367ea4eb4db5?q=80&w=200&auto=format&fit=crop" className="w-full h-full object-cover" alt="Post 2" />
                     </div>
                  </div>
               </div>
            </div>
         </div>

      </div>
    </div>
  );
};
